import * as fromDatatype from "../datatype-library/index";

export interface BasicWarrantyJsonInterface extends fromDatatype.JsonDatatypeInterface {
  days?: number
  months?: number
  years?: number
}

type DeliveryChargesConfigJsonInterface = fromDatatype.JsonDatatypeInterface & { func: string } & { [paramKeys: string]: string | number }

export interface bl_fi_mst_item_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  category: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  code_alias_json: fromDatatype.JsonDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  prompt_purchase: fromDatatype.TextDatatypeInterface;
  prompt_sales: fromDatatype.TextDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  price_json?: Object;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  txn_class: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  ccy_xrate: fromDatatype.VarcharDatatypeInterface;
  scan_code: fromDatatype.VarcharDatatypeInterface;
  sub_item_type: fromDatatype.VarcharDatatypeInterface;
  coupon_hdr_guid: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  emp_status: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  dim_width: fromDatatype.NumericDatatypeInterface;
  dim_height: fromDatatype.NumericDatatypeInterface;
  dim_length: fromDatatype.NumericDatatypeInterface;
  dim_weight: fromDatatype.NumericDatatypeInterface;
  consignment_flg: boolean;
  tax_country: fromDatatype.VarcharDatatypeInterface;
  input_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  tax_applicable: boolean;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  product_ranking: fromDatatype.NumericDatatypeInterface;
  cfg_production: fromDatatype.VarcharDatatypeInterface;
  cfg_delivery: fromDatatype.VarcharDatatypeInterface;
  cashbook_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  seo_schema_json: fromDatatype.JsonDatatypeInterface;
  cfg_preorder: fromDatatype.VarcharDatatypeInterface;
  membership_class_guid: fromDatatype.GuidDataFieldInterface;
  extended_warranty_years: fromDatatype.IntegerDatatypeInterface;
  title_writer: fromDatatype.VarcharDatatypeInterface;
  meta_desc: fromDatatype.VarcharDatatypeInterface;
  scheme_generator: fromDatatype.JsonDatatypeInterface;
  label_hdr_guid: fromDatatype.GuidDataFieldInterface;
  main_image_guid: fromDatatype.GuidDataFieldInterface;
  input_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  pricing_logic: fromDatatype.VarcharDatatypeInterface;
  valid_date_start: fromDatatype.TimestampTzDatatypeInterface;
  valid_date_end: fromDatatype.TimestampTzDatatypeInterface;
  label_hdr_1_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_2_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_3_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_4_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_5_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_6_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_7_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_8_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_9_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_10_guid: fromDatatype.GuidDataFieldInterface;
  sales_contract_template_guid: fromDatatype.GuidDataFieldInterface;
  alt_item_code_01: fromDatatype.VarcharDatatypeInterface;
  alt_item_code_02: fromDatatype.VarcharDatatypeInterface;
  basic_warranty_json: BasicWarrantyJsonInterface;
  delivery_charge_config_json: DeliveryChargesConfigJsonInterface;
  has_basic_warranty: boolean;
  free_shipping: boolean;
  cfg_serial_no: fromDatatype.VarcharDatatypeInterface;
  pic_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  membership_points_ccy_guid: fromDatatype.GuidDataFieldInterface;
  stl_limit_amount: fromDatatype.NumericDatatypeInterface;
  stl_limit_percentage: fromDatatype.NumericDatatypeInterface;
  conditional_filter_json: fromDatatype.JsonDatatypeInterface;
  grouped_attribute_1_guid: fromDatatype.GuidDataFieldInterface;
  grouped_attribute_2_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_11_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_12_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_13_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_14_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_15_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_16_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_17_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_18_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_19_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_20_guid: fromDatatype.GuidDataFieldInterface;
  wms_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_item_classification_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_item_classification_code: fromDatatype.VarcharDatatypeInterface;
  einvoice_item_classification_desc: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_taxable_type_code: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_desc: fromDatatype.VarcharDatatypeInterface;
  einvoice_uom: fromDatatype.VarcharDatatypeInterface;
  einvoice_uom_desc: fromDatatype.TextDatatypeInterface;
  grouped_attribute_json: fromDatatype.JsonDatatypeInterface;
  glcode_guid: fromDatatype.GuidDataFieldInterface;
  glcode_guid_sales_revenue: fromDatatype.GuidDataFieldInterface;
  glcode_guid_sales_returns: fromDatatype.GuidDataFieldInterface;
  glcode_guid_sales_discount: fromDatatype.GuidDataFieldInterface;
  glcode_guid_purchase: fromDatatype.GuidDataFieldInterface;
  glcode_guid_purchase_returns: fromDatatype.GuidDataFieldInterface;
  glcode_guid_purchase_discount: fromDatatype.GuidDataFieldInterface;
  inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  settlement_type: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  additional_remarks_1: fromDatatype.VarcharDatatypeInterface;
  additional_remarks_2: fromDatatype.VarcharDatatypeInterface;
  alias_of_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  card_charges_json: any;
  min_mrp_stock_qty: fromDatatype.NumericDatatypeInterface;
  tax_rate_output: fromDatatype.NumericDatatypeInterface;
  tax_code_output: fromDatatype.VarcharDatatypeInterface;
  tax_type_output: fromDatatype.VarcharDatatypeInterface;
  tax_rate_withholding: fromDatatype.NumericDatatypeInterface;
  tax_code_withholding: fromDatatype.VarcharDatatypeInterface;
  tax_type_withholding: fromDatatype.VarcharDatatypeInterface;
  marketplace_url: any;
  additional_remarks_3: fromDatatype.TextDatatypeInterface;
  additional_remarks_4: fromDatatype.TextDatatypeInterface;
}

export class bl_fi_mst_item_hdr_RowClass implements bl_fi_mst_item_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  category: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  code_alias_json: fromDatatype.JsonDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  prompt_purchase: fromDatatype.TextDatatypeInterface;
  prompt_sales: fromDatatype.TextDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  price_json?: Object;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  txn_class: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  ccy_xrate: fromDatatype.VarcharDatatypeInterface;
  scan_code: fromDatatype.VarcharDatatypeInterface;
  sub_item_type: fromDatatype.VarcharDatatypeInterface;
  coupon_hdr_guid: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  emp_status: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  dim_width: fromDatatype.NumericDatatypeInterface;
  dim_height: fromDatatype.NumericDatatypeInterface;
  dim_length: fromDatatype.NumericDatatypeInterface;
  dim_weight: fromDatatype.NumericDatatypeInterface;
  consignment_flg: boolean;
  tax_country: fromDatatype.VarcharDatatypeInterface;
  input_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  tax_applicable: boolean;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  product_ranking: fromDatatype.NumericDatatypeInterface;
  cfg_production: fromDatatype.VarcharDatatypeInterface;
  cfg_delivery: fromDatatype.VarcharDatatypeInterface;
  cashbook_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  seo_schema_json: fromDatatype.JsonDatatypeInterface;
  cfg_preorder: fromDatatype.VarcharDatatypeInterface;
  membership_class_guid: fromDatatype.GuidDataFieldInterface;
  extended_warranty_years: fromDatatype.IntegerDatatypeInterface;
  title_writer: fromDatatype.VarcharDatatypeInterface;
  meta_desc: fromDatatype.VarcharDatatypeInterface;
  scheme_generator: fromDatatype.JsonDatatypeInterface;
  label_hdr_guid: fromDatatype.GuidDataFieldInterface;
  main_image_guid: fromDatatype.GuidDataFieldInterface;
  input_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  pricing_logic: fromDatatype.VarcharDatatypeInterface;
  valid_date_start: fromDatatype.TimestampTzDatatypeInterface;
  valid_date_end: fromDatatype.TimestampTzDatatypeInterface;
  label_hdr_1_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_2_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_3_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_4_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_5_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_6_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_7_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_8_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_9_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_10_guid: fromDatatype.GuidDataFieldInterface;
  ttl_view_count: fromDatatype.NumericDatatypeInterface;
  sales_contract_template_guid: fromDatatype.GuidDataFieldInterface;
  alt_item_code_01: fromDatatype.VarcharDatatypeInterface;
  alt_item_code_02: fromDatatype.VarcharDatatypeInterface;
  basic_warranty_json: BasicWarrantyJsonInterface;
  delivery_charge_config_json: DeliveryChargesConfigJsonInterface;
  has_basic_warranty: boolean;
  free_shipping: boolean;
  cfg_serial_no: fromDatatype.VarcharDatatypeInterface;
  pic_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  membership_points_ccy_guid: fromDatatype.GuidDataFieldInterface;
  stl_limit_amount: fromDatatype.NumericDatatypeInterface;
  stl_limit_percentage: fromDatatype.NumericDatatypeInterface;
  conditional_filter_json: fromDatatype.JsonDatatypeInterface;
  grouped_attribute_1_guid: fromDatatype.GuidDataFieldInterface;
  grouped_attribute_2_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_11_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_12_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_13_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_14_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_15_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_16_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_17_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_18_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_19_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_20_guid: fromDatatype.GuidDataFieldInterface;
  wms_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_item_classification_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_item_classification_code: fromDatatype.VarcharDatatypeInterface;
  einvoice_item_classification_desc: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_taxable_type_code: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_desc: fromDatatype.VarcharDatatypeInterface;
  einvoice_uom: fromDatatype.VarcharDatatypeInterface;
  einvoice_uom_desc: fromDatatype.TextDatatypeInterface;
  grouped_attribute_json: fromDatatype.JsonDatatypeInterface;
  glcode_guid: fromDatatype.GuidDataFieldInterface;
  glcode_guid_sales_revenue: fromDatatype.GuidDataFieldInterface;
  glcode_guid_sales_returns: fromDatatype.GuidDataFieldInterface;
  glcode_guid_sales_discount: fromDatatype.GuidDataFieldInterface;
  glcode_guid_purchase: fromDatatype.GuidDataFieldInterface;
  glcode_guid_purchase_returns: fromDatatype.GuidDataFieldInterface;
  glcode_guid_purchase_discount: fromDatatype.GuidDataFieldInterface;
  inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  settlement_type: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  additional_remarks_1: fromDatatype.VarcharDatatypeInterface;
  additional_remarks_2: fromDatatype.VarcharDatatypeInterface;
  alias_of_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  card_charges_json: any;
  min_mrp_stock_qty: fromDatatype.NumericDatatypeInterface;
  tax_rate_output: fromDatatype.NumericDatatypeInterface;
  tax_code_output: fromDatatype.VarcharDatatypeInterface;
  tax_type_output: fromDatatype.VarcharDatatypeInterface;
  tax_rate_withholding: fromDatatype.NumericDatatypeInterface;
  tax_code_withholding: fromDatatype.VarcharDatatypeInterface;
  tax_type_withholding: fromDatatype.VarcharDatatypeInterface;
  marketplace_url: any;
  additional_remarks_3: fromDatatype.TextDatatypeInterface;
  additional_remarks_4: fromDatatype.TextDatatypeInterface;
}
